import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { Activity } from "lucide-react";

const pub = axios.create({ baseURL: API });
const ROTATE_MS = 4200;

/**
 * Subtle ticker that rotates real activity from opted-in beekeepers
 * (e.g. "Anna H. in Vienna, Austria just logged a new inspection").
 * Falls back to nothing when the endpoint returns an empty list.
 */
export default function SocialProofRotator() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    pub.get("/public/social-proof", { params: { limit: 10 } })
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => setItems([]));
  }, []);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), ROTATE_MS);
    return () => clearInterval(t);
  }, [items.length]);

  if (items.length === 0) return null;
  const cur = items[idx];

  return (
    <div
      className="mt-8 inline-flex items-center gap-2.5 text-xs text-stone-600 bg-white/60 backdrop-blur-sm border border-stone-200/70 rounded-full px-4 py-2"
      data-testid="social-proof-rotator"
      aria-live="polite"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" aria-hidden="true" />
      <Activity className="w-3.5 h-3.5 text-amber-700" aria-hidden="true" />
      <span key={`${cur.name}-${cur.when}-${idx}`} className="social-proof-line whitespace-nowrap" data-testid="social-proof-line">
        <span className="font-medium text-stone-800">{cur.name}</span>
        {cur.location && <> in <span className="text-stone-700">{cur.location}</span></>}
        {" just "}
        <span className="text-amber-800">{cur.action}</span>
      </span>
    </div>
  );
}
